.adder {
    margin-left: -10px; /* Offsets button padding */
}
